import type { oz } from '@weft/utils';
import { created } from '../../../../utils/created';
import { NewUsageLineItemSchema } from './new-usage-line-item-schema';

export const UsageLineItemSchema = created(NewUsageLineItemSchema).openapi('UsageLineItem');

export type UsageLineItem = oz.infer<typeof UsageLineItemSchema>;